import { render, staticRenderFns } from "./ProfileMain.vue?vue&type=template&id=209f6fb0&scoped=true"
import script from "./ProfileMain.vue?vue&type=script&lang=js"
export * from "./ProfileMain.vue?vue&type=script&lang=js"
import style0 from "./ProfileMain.vue?vue&type=style&index=0&id=209f6fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209f6fb0",
  null
  
)

export default component.exports